import {
  Close as ClearIcon,
  HomeRepairService as ToolboxIcon,
} from "@mui/icons-material";
import { action, makeObservable, observable } from "mobx";
import React from "react";

import Input from "../Input/Input";
import List from "../List/List";
import Button from "./Button";
import MenuButton from "./MenuButton";
import { ButtonPropTypes } from "./buttonPropsTypes";
import injectStores from "../RootStore/injectStores";
import AppLayoutStore from "stores/AppLayoutStore";
import ThemeStore from "stores/ThemeStore";
import { RouterStore } from "stores/RouterStore";

interface ToolboxButtonMenuProps extends ButtonPropTypes {
  appLayoutStore?: AppLayoutStore;
  themeStore?: ThemeStore;
  routerStore?: RouterStore;
  closeMenu: () => void;
}

interface RouteShortcut {
  key: string;
  title: string;
  icon: React.ElementType;
}

export interface customRowRendererProps {
  index: number;
  style?: React.CSSProperties;
  rowData: RouteShortcut;
}

class ToolboxButtonMenu extends React.PureComponent<ToolboxButtonMenuProps> {
  filter = "";
  constructor(props: ToolboxButtonMenuProps) {
    super(props);
    makeObservable(this, {
      filter: observable,
      setFilter: action,
      // scrollToIndexValue: computed,
      // filteredItems: computed,
    });
  }
  setFilter = (value: string) => {
    this.filter = value;
  };
  clear = () => {
    this.filter = "";
  };
  handleEnterKey = (event: React.KeyboardEvent<HTMLInputElement>): void => {
    if (event.key === "Enter" && this.filter && this.filteredItems.length > 0) {
      return this.handleClick(this.filteredItems[0]);
    }
  };
  handleClick = (rowData: { key: string; title: string }) => {
    const { routerStore, closeMenu } = this.props;
    routerStore.goTo(rowData.key, { ...routerStore.params });
    return closeMenu();
  };
  get filteredItems() {
    const { appLayoutStore } = this.props;
    if (!appLayoutStore.toolboxRoutes) return [];
    return appLayoutStore.toolboxRoutes
      .filter((route: { key: string; title: string }) => {
        if (!this.filter) return true;
        return route.title.toLowerCase().includes(this.filter.toLowerCase());
      })
      .map((route: { key: string; title: string }) => {
        return { key: route.key, title: route.title, icon: ToolboxIcon };
      })
      .sort((a: RouteShortcut, b: RouteShortcut) => {
        if (a.title.includes("Dashboard")) return -1;
        if (b.title.includes("Dashboard")) return 1;
        return 0;
      });
  }
  get scrollToIndexValue() {
    const { appLayoutStore, routerStore } = this.props;
    if (appLayoutStore && appLayoutStore.isRightMenuSelection) {
      return this.filteredItems
        .slice()
        .findIndex(
          (pageName: RouteShortcut) =>
            pageName.title === routerStore?.currentRoute?.title
        );
    }
    return undefined;
  }

  render() {
    const { themeStore } = this.props;
    return (
      <div>
        <div style={{ height: 50, width: 260 }}>
          <Input
            labelText={"Filter Tools"}
            value={this.filter}
            autoFocus
            fullWidth
            onChange={(value: string) => this.setFilter(value)}
            onKeyPress={(event: React.KeyboardEvent<HTMLInputElement>) =>
              this.handleEnterKey(event)
            }
            endAdornment={
              <>
                <Button
                  tooltip="Clear"
                  onClick={() => {
                    this.clear();
                  }}
                  color="transparent"
                  justIcon
                >
                  <ClearIcon />
                </Button>
              </>
            }
          />
        </div>
        <List
          height={300}
          width={280}
          rows={[...this.filteredItems]}
          scrollToIndex={this.filter ? 0 : this.scrollToIndexValue}
          customRowRenderer={(currentProps) => {
            const props = currentProps as customRowRendererProps;
            const Icon = props.rowData?.icon;
            const currentRoute = this.scrollToIndexValue === props.index;
            const border = currentRoute
              ? `2px solid ${themeStore.currentTheme.palette.secondary.main}`
              : undefined;
            return (
              <div
                onClick={() => this.handleClick(props.rowData)}
                style={{
                  ...props.style,
                  height:
                    typeof props.style?.height === "number"
                      ? props.style.height - 4
                      : "auto",
                  width: "95%",
                  cursor: "pointer",
                  borderRadius: "6px",
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  border: border,
                }}
              >
                {Icon && <Icon />}
                <h4
                  style={{
                    margin: "12px",
                  }}
                >
                  {props.rowData.title}
                </h4>
              </div>
            );
          }}
        />
      </div>
    );
  }
}
const WrappedToolboxButtonMenu = injectStores(ToolboxButtonMenu);

interface ToolboxButtonProps {
  color?: "primary" | "secondary" | "success" | "info" | "warning" | "danger" | "gray" | "white" | "transparent";
}

class ToolboxButton extends React.PureComponent<ToolboxButtonProps> {
  render() {
    const { color = "white" } = this.props;
    return (
      <MenuButton
        color={color}
        justIcon
        autosize
        menuStyle={{ padding: 10 }}
        menu={({ closeMenu }: { closeMenu: () => void }) => (
          <WrappedToolboxButtonMenu closeMenu={closeMenu} />
        )}
      >
        <ToolboxIcon />
      </MenuButton>
    );
  }
}
// ToolboxButton.defaultProps = {
//   color: "white",
// };

const ToolboxButtonWithStores = injectStores(ToolboxButton);
export default ToolboxButtonWithStores;
